import { PublicationType } from "@colibrio/colibrio-reader-framework/colibrio-core-publication-base";
import type { LatestConfig } from "../../../../app/configuration/schemas";
import { RendererType } from "../../../../app/configuration/types";

export const CirrusDefaultConfig = {
  public: {
    language: "en-GB",
    theme: "Default",
    fonts: 
      {
        name: "components.publication_default",
      },
      /*{
        name: "Easy Reading",
        defaults: {
          fallback: "EasyReading",
        },
        fontFaces: [
          {
            family: "EasyReading",
            mediaType: MediaType.FONT_TTF,
            src: EasyReadingPRO,
          },
        ],
      },
      {
        name: "Ysabeau Infant",
        defaults: {
          fallback: "Ysabeau Infant",
        },
        fontFaces: [
          {
            family: "Ysabeau Infant",
            mediaType: MediaType.FONT_TTF,
            //srcUrl: "https://s3.eu-north-1.amazonaws.com/assets.demo.colibrio.com/fonts/YsabeauInfant-VariableFont_wght.ttf",
            src: YsabeauInfant
          },
        ],
      }*/
    
    settings: {
      fontSize: {
        enabled: true,
        value: '100%',
      },
      fontFamily: {
        enabled: true,
        value: 'components.publication_default'
      },
      lineHeight: {
        enabled: false
      },
      wordSpacing: {
        enabled: false
      },
      letterSpacing: {
        enabled: false
      },
      ignoreAspectRatio: {
        enabled: false
      },
      logos: {
        full:"",
        icon:""
      }
    },
    formats: [PublicationType.PDF, PublicationType.EPUB],
    renderers: [RendererType.enum.SpreadSwipeRenderer],
  }
 } as unknown as LatestConfig;
